module.exports = __webpack_public_path__ + "static/media/insu-msh.450a8a6a.svg";